export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_PATH = process.env.REACT_APP_API_PATH;
export const REQUEST_TIMEOUT = process.env.REACT_APP_REQUEST_TIMEOUT
  ? parseInt(process.env.REACT_APP_REQUEST_TIMEOUT)
  : undefined;
